import {WomanSimilarCaseDetected} from './woman-similar-case-detected';

export class WomanSimilarCaseResponse {

    similar: boolean;
    cases: WomanSimilarCaseDetected[];

}
